<template>
  <section class="l-content">
    <el-card>
      <el-form :inline="true" :model="condition">
        <el-form-item label="所属企业">
          <l-select v-model="condition.enterpriseCode" :remote="$api.enterpriseList" @change="getPageData"></l-select>
        </el-form-item>
        <el-form-item label="记录状态">
          <l-select v-model="condition.borrowState" :data="$constant.myCarBorrowStateList" @change="getPageData"></l-select>
        </el-form-item>
        <el-form-item label="使用时间">
          <l-datepicker type="daterange" :default="[condition.startDate, condition.endDate]" @change="dataRangeChange"></l-datepicker>
        </el-form-item>
        <el-form-item>
          <el-input v-model="condition.keyword" placeholder="车牌号/使用人姓名"> </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getPageData()">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-divider> </el-divider>
    <el-card v-if="pageData">
      <l-table :option="tableOption" :data="pageData.list" :start-index="pageData.startIndex">
        <template slot="enterpriseName" slot-scope="scope">
          <el-button type="text" @click="$site.view_enterprise_detail(scope.row.enterpriseCode)">{{ scope.row.enterpriseName }}</el-button>
        </template>
        <!--栏目插槽：计划出发时间/出发地-->
        <template slot="startTime" slot-scope="scope">
          <p>
            {{ scope.row.startTime | limitTo(16) }}
          </p>
          <p class="text-cut">
            {{ scope.row.startPlace }}
          </p>
        </template>
        <!--栏目插槽：计划返回时间/到达地-->
        <template slot="endTime" slot-scope="scope">
          <p>
            {{ scope.row.endTime | limitTo(16) }}
          </p>
          <p class="text-cut">
            {{ scope.row.endPlace }}
          </p>
        </template>
        <template slot="borrowState" slot-scope="scope">
          <span v-if="scope.row.borrowState == 0" class="text-blue">未提交</span>
          <span v-else-if="scope.row.borrowState == 1" class="text-orange">已提交</span>
          <span v-else-if="scope.row.borrowState == 10" class="text-green">已审批</span>
        </template>
      </l-table>
      <l-pager :page="pageData" @change="getPageData"></l-pager>
    </el-card>
  </section>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['userInfo'])
  },
  name: 'BorrowList',
  data() {
    return {
      tableOption: {
        stripe: true,
        height: document.documentElement.clientHeight - 280 + 'px',
        columns: [
          { label: '序号', type: 'index' },
          { label: '所属企业', slot: 'enterpriseName' },
          { label: '用车人', prop: 'userName' },
          { label: '车牌号', prop: 'carNo' },
          { label: '用车事由', prop: 'workType' },
          { label: '出发时间/地点', slot: 'startTime' },
          { label: '返回时间/到达地', slot: 'endTime' },
          { label: '导航距离', prop: 'posDistance' },
          { label: '状态', slot: 'borrowState' }
        ]
      },
      condition: {
        keyword: '',
        enterpriseCode: '',
        startDate: '',
        endDate: '',
        borrowState: '',
        pageIndex: 1,
        pageSize: 10
      },
      pageData: null
    }
  },
  created() {
    this.getPageData()
  },
  methods: {
    dataRangeChange(d1, d2) {
      this.condition.startDate = d1
      this.condition.endDate = d2
    },
    async getPageData(pageOption) {
      Object.assign(this.condition, pageOption)
      this.pageData = await this.$lgh.get('api/user/mycar/borrow/pagelist', this.condition)
    }
  }
}
</script>
